import { render } from "./SongDetails.vue?vue&type=template&id=4446957b"
import script from "./SongDetails.vue?vue&type=script&lang=js"
export * from "./SongDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__